import React, { useState } from "react";
import Dashboard from "../Dashboard";
import ListContacts from "../../../features/adminDashboard/contacts/ListContacts";
import CreateContact from "../../../features/adminDashboard/contacts/CreateContact";

function Contacts() {
  const [activeTab, setActiveTab] = useState("list");
  return (
    <Dashboard>
      <div className="w-full h-full px-4 pb-8">
        {/* Tab Navigation */}
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
          <button
            onClick={() => setActiveTab("list")}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              activeTab === "list"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            List Contacts
          </button>
          <button
            onClick={() => setActiveTab("create")}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              activeTab === "create"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            Create Contact
          </button>
        </div>
        {activeTab === "list" && <ListContacts onSetActiveTab={setActiveTab} />}
        {activeTab === "create" && (
          <CreateContact onSetActiveTab={setActiveTab} />
        )}
      </div>
    </Dashboard>
  );
}

export default Contacts;
